/*@ngInject*/
const RateStatusRepository = function (baseRepository) {

    angular.extend(this, baseRepository);

    this.loadActions = function () {
        const url = '/rest/Actions',
            config = {
                params: {
                    uri: 'com.firstbest.underwriting.staterate.StateRate:null'
                }
            };

        return this.get(url, config);
    };

    this.saveStateRates = function (stateRates) {
        const url = '/rest/StateRate/update',
            body = stateRates,
            config = {
                params: {}
            };
        return this.post(url, body, config);
    };

    this.loadStateRates = function (params) {
        const url = '/rest/StateRate/List',
            config = {
                params: {}
            };

        return this.get(url, config);
    };

};

angular.module('ums.configuration')
    .service('rateStatusRepository', RateStatusRepository);

